import type { Gateway } from '@si/types';
import { patch } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string;
  gatewayId: number;
  editedGateway: Gateway;
}

export function useUpdateGateway() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      patch({
        url: `/projects/${params.projectId}/gateways/${params.gatewayId}`,
        body: params.editedGateway,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getGateways(variables.projectId, 'installationId'),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getGateways(variables.projectId, variables.installationId),
      });
    },
  });

  const updateGateway = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    updateGateway,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
